

export const tableStyles = {
    table: {
        tableLayout: "fixed",
        width: "100%",
        "& .MuiTableCell-root": {
            BorderBottom: "0.5px solid #9ca3af",
            padding: "4px 8px",
        },
    },

    body: {
        "& .MuiTableCell-root": {
            padding: "4px",
        },
    },

    headerCell: {
        fontWeight: 700,
        padding: "16px 8px 12px 8px !important",
    },

    titleCell: {
        fontWeight: 700,
        textTransform: "uppercase",
        backgroundColor: "#f9fafb",
        padding: "4px 8px !important",

    },

    level1: {
        fontWeight: 700,
    },

    nameCell: {
        fontSize: "13px",
        padding: "4px 8px",
    },
};